namespace TabAurous {
    export interface OwnStockRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Stock.StockItemRow[];
    }
}
